<template>
  <div class="pr-5">
    <ColumnChart
      :height="200"
      :chartData="chartData"
      :options="chartOptions"
    ></ColumnChart>
    <div class="mt-2 text-secondary text-center">
      Кликните на колонку, чтобы открыть подробности
    </div>
    <b-icon
      id="legend"
      variant="info"
      class="legend"
      icon="info-circle"
      font-scale="1.5"
    ></b-icon>
    <b-tooltip
      custom-class="legend__tooltip"
      target="legend"
      placement="left"
    >
      <ul>
        <li v-for="(group, key) in groups" :key="key">
          <b>{{ group.label }}</b> - {{ group.description }}
        </li>
      </ul>
    </b-tooltip>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ColumnChart from "@components/charts/ColumnChart.vue";
import { PORTFOLIO_GROUPS, groupLabel, groupColor } from "./portfolioGroups";

// Неактивные колонки приглушаются, чтобы было видно, какая группа открыта в таблице
const INACTIVE_ALPHA = "66";

export default {
  components: {
    ColumnChart,
  },

  props: {
    // { group: count }
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      groups: PORTFOLIO_GROUPS,
      chartOptions: {
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: true,
                min: 0,
                precision: 0,
              },
            },
          ],
          xAxes: [
            {
              stacked: false,
            },
          ],
        },
        onClick: (_, item) => {
          if (item.length > 0) {
            const key = Object.keys(this.data)[item[0]._index];
            if (key) {
              this.selectGroup(key);
            }
          }
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? "pointer" : "default";
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  computed: {
    ...mapState("clientPortfolio", ["group"]),

    chartData() {
      const keys = Object.keys(this.data);
      const colors = keys.map((key) => {
        const color = groupColor(key);
        return !this.group || key === this.group ? color : color + INACTIVE_ALPHA;
      });

      return {
        labels: keys.map(groupLabel),
        datasets: [
          {
            maxBarThickness: 70,
            data: keys.map((key) => this.data[key]),
            backgroundColor: colors,
            hoverBackgroundColor: keys.map(groupColor),
          },
        ],
      };
    },
  },

  methods: {
    ...mapActions("clientPortfolio", ["selectGroup"]),
  },
};
</script>

<style lang="scss">
.legend {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: help;

  &__tooltip {
    cursor: help;
    .tooltip-inner {
      max-width: 400px;
      text-align: left;
      padding: 15px;

      ul {
        margin: 0;
      }

      li:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
